export interface RecoveryEmailFormData {
  email: string;
  password: string;
  confirmPassword: string;
}

export interface RecoveryEmailDialogData {
  userId: number;
  flow: RecoveryEmailFlowType;
  flowStep: RecoveryEmailStep;
  recoveryEmail?: string;
}

export enum RecoveryEmailStep {
  COMPLETE_ACCOUNT = 'complete_account',
  ONE_STEP_AWAY = 'one_step_away',
}

export interface RecoveryEmailStatus {
  dialogClosed: boolean;
  data?: RecoveryEmailDialogData;
}

export type RecoveryEmailFlowType = 'noPassword' | 'hasPassword';
